import { apiAction } from 'client/redux/apiHelpers';

export const forgotPassword = (types, form) => {
  return apiAction({
    endpoint: '/api/user/forgotPassword',
    method: 'POST',
    types,
    json: form,
  });
};
